"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LearningTableBodyCell = void 0;
var React = require("react");
var _1 = require("./");
var LearningTableBodyCell = function (_a) {
    var cellInfo = _a.cellInfo, cellName = _a.cellName, specificClassName = _a.specificClassName;
    var cellData = React.useMemo(function () {
        var result = cellInfo[cellName];
        if (cellName === _1.LearningComponentHeaderCellEnum.Language && cellInfo.language) {
            result = cellInfo.language.join(', ');
        }
        if (cellName === _1.LearningComponentHeaderCellEnum.LearningType &&
            cellInfo.learningType === 'course') {
            result = cellInfo[cellName] + ' - ' + cellInfo.deliveryTypes.join(', ');
        }
        return result;
    }, [cellInfo, cellName]);
    return React.createElement("span", { className: "learning-table-body-cell-text ".concat(specificClassName) }, cellData);
};
exports.LearningTableBodyCell = LearningTableBodyCell;
